import styled from "styled-components";
import Text from "./Text";

export const T = styled(Text)`
    font-family: ${(props) => props.theme.font.t["font-family"]};
    font-style: ${(props) => props.theme.font.t["font-style"]};
    font-weight: ${(props) => props.theme.font.t["font-weight"]};
    font-size: ${(props) => props.theme.font.t["font-size"]};
    line-height: ${(props) => props.theme.font.t["line-height"]};
`;

export default T;
